import { render, staticRenderFns } from "./ProductConfig.vue?vue&type=template&id=3e4504f8&"
import script from "./ProductConfig.vue?vue&type=script&lang=js&"
export * from "./ProductConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports